export default __webpack_public_path__ + "static/media/game_fish.bd2f7c5a.png";